import { CSSProperties, memo } from 'react';
import styled from '@emotion/styled';
import { imagePath } from 'presentations/assets';
import { borderRadius } from 'presentations/views/styles';

interface Props {
  className?: string;
  src: string;
  alt: string;
  loading?: 'lazy' | 'eager' | 'auto';
  width?: number;
  height?: number;
  fit?: string;
  fill?: string;
  locale?: string;
  style?: CSSProperties;
  dpr?: number;
}

export const getImageUrlWithLocale = (src: string, locale: string) => {
  const arr = src.split('.');
  arr.splice(arr.length - 1, 0, locale);
  return arr.join('.');
};

const Component = memo((props: Props) => {
  const attr = {
    width: props.width,
    height: props.height,
    fit: props.fit,
    fill: props.fill,
  };
  let srcSet = null;
  let sizes = null;
  const src = props.locale
    ? getImageUrlWithLocale(props.src, props.locale)
    : props.src;
  const imageSrc = imagePath(src, attr);
  if (props.width && props.height && props.dpr !== undefined) {
    const srcSets: string[] = [];
    srcSets.push(
      `${imagePath(src, {
        ...attr,
        width: props.width / 2,
        height: props.height / 2,
      })} ${props.width / 2}w`,
    );
    for (let dpr = 1; dpr <= props.dpr; dpr++) {
      srcSets.push(`${imagePath(src, { ...attr, dpr })} ${props.width * dpr}w`);
    }
    srcSet = srcSets.join(',');
    sizes = '100vw';
  }
  let loading = undefined;
  if (props.loading !== 'auto') {
    loading = props.loading || 'lazy';
  }
  return (
    <Image
      className={props.className}
      srcSet={srcSet || undefined}
      sizes={sizes || undefined}
      src={imageSrc || undefined}
      alt={props.alt}
      loading={loading}
      style={props.style}
      width={props.width}
      height={props.height}
    />
  );
});

const Image = styled.img`
  border-radius: ${borderRadius(4)};
  svg {
    fill: currentColor;
  }
  color: blue;
`;

export default Component;
